import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kebabmenu",
  "use": "icon-kebabmenu-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-kebabmenu\">\n  <path fill=\"currentColor\" d=\"M10 16a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm0-4.8a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm0-4.8A1.2 1.2 0 1110 4a1.2 1.2 0 010 2.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol